<template>
  <div>
    <!-- 导航条 -->
    <top-nav></top-nav>
    <!-- 背景图 -->
    <img
      v-if="bannerList.length !== 0"
      :src="bannerList[0].CompanyName"
      class="img-fluid bg-img"
    />
    <!-- 面包屑 -->
    <div style="background-color: #f5f5f5;">
      <div class="crumbs_wrap type_area">
        <i class="iconfont iconweizhi1"></i>
        <span>您当前所在的位置：</span>
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">首页</li>
          <li class="breadcrumb-item active" aria-current="page">品牌招商</li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ crumbs }}
          </li>
        </ol>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="brand_wrap">
      <div class="dynamic_wrap type_area">
        <div class="dynamic_title">
          <div>品牌招商</div>
          <div>ATTRACT INVESTMENT</div>
        </div>

        <div class="cut_tier_wrap">
          <div
            :class="[
              'tier_item',
              enterCurrentIndex == item.Id ? 'enter_active' : ''
            ]"
            v-for="item in navSonList"
            :key="item.Id"
            @click="handleEnterActive(item)"
          >
            {{ item.Title }}
          </div>
        </div>
        <!-- 项目优势 开始 -->
        <div class="advantage_wrap" v-if="enterCurrentIndex == 163">
          <div v-html="advantage[0].Ncor"></div>
        </div>
        <!-- 项目优势 结束 -->

        <!-- 招商政策 开始 -->
        <div class="advantage_wrap" v-else-if="enterCurrentIndex == 164">
          <div v-html="policy[0].Ncor"></div>
        </div>
        <!-- 招商政策 结束 -->

        <!-- 入驻申请 开始 -->
        <div class="settled_wrap" v-else-if="enterCurrentIndex == 162">
          <!-- 输入框 -->
          <div class="ipt_wrap">
            <!-- 姓名 -->
            <div class="input-group mb-3">
              <div>姓名 <span style="color: #b92e32;">*</span></div>
              <input
                type="text"
                class="form-control"
                v-model="params.CompanyName"
                placeholder="请输入您的姓名"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <!-- 电话 -->
            <div class="input-group mb-3">
              <div>电话 <span style="color: #b92e32;">*</span></div>
              <input
                type="text"
                class="form-control"
                v-model="params.CompanyPhone"
                placeholder="请输入您的电话"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <!-- QQ -->
            <div class="input-group mb-3">
              <div>QQ/MSN</div>
              <input
                type="text"
                class="form-control"
                v-model="params.CompanyScale"
                placeholder="请输入您的QQ/MSN"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <!-- 服务项 -->
            <div class="form-group input-group mb-3">
              <div>您是 <span style="color: #b92e32;">*</span></div>
              <select
                class="form-control"
                v-model="params.Nitype"
                id="exampleFormControlSelect1"
              >
                <option
                  v-for="item in settledList"
                  :key="item.Value"
                  :value="item.Value"
                >
                  {{ item.Description }}
                </option>
              </select>
            </div>
            <!-- 城市 -->
            <div class="input-group mb-3">
              <div>所在的城市</div>
              <input
                type="text"
                class="form-control"
                v-model="params.Address"
                placeholder="请输入您所在的城市"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <!-- 时间 -->
            <div class="input-group mb-3">
              <div>时间要求</div>
              <input
                type="text"
                class="form-control"
                v-model="params.Sxtime"
                placeholder="请输入您的时间"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <!-- 附加 -->
            <div class="input-group mb-3">
              <div>附加说明</div>
              <textarea
                class="form-control"
                v-model="params.LegalPerson"
                placeholder="请输入您的需求"
                aria-label="With textarea"
              ></textarea>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="btn_wrap">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="handleSubmitFrom"
            >
              提交申请
            </button>
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              @click="handleClearFrom"
            >
              重置申请
            </button>
          </div>
          <!-- 文字 -->
          <div class="title_wrap">
            <p>
              凡在此填写预约需求表单的朋友,金多银多客服将第一时间安排与您取得联系，免费为您提供珠宝咨询服务
            </p>
            <p>
              注：标 *
              号的为必填项；您的信息会受到严格保密，仅为客服联系您预约提供方便，不作其它用途
            </p>
          </div>
        </div>
        <!-- 入驻申请 结束 -->

        <!-- 客户服务 开始 -->
        <div class="show_wrap" v-else>
          <div class="promise_wrap">
            <img src="../../assets/index_img/logo_02.png" />
            <p class="user">尊敬的用户</p>
            <div v-html="footerInfo.Welcome"></div>
            <!-- <p>欢迎您加入金多银多珠宝广场</p>
            <p>如果您对我们的工作有什么意见或建议</p>
            <p>请及时联系我们</p>
            <p>我们将竭诚为您服务！</p> -->
          </div>
          <div class="relation_wrap">
            <div class="phone_box">
              <h2>常用电话</h2>
              <ul class="phone_ui">
                <li class="phone_item">
                  <i class="iconfont icondianhua"></i>
                  <div class="title">
                    <span>服务电话</span>
                    <span>{{ footerInfo.CompanyPhone }}</span>
                  </div>
                </li>
                <li class="phone_item">
                  <i class="iconfont icondianhua"></i>
                  <div class="title">
                    <span>招商电话</span>
                    <span>{{ footerInfo.CompanyZhao }}</span>
                  </div>
                </li>
                <li class="phone_item">
                  <i class="iconfont icondianhua"></i>
                  <div class="title">
                    <span>广告合作</span>
                    <span>{{ footerInfo.CompanyHe }}</span>
                  </div>
                </li>
              </ul>
            </div>

            <div class="wx_box">
              <h2>金多银多珠宝广场官方微信</h2>
              <div class="code_box">
                <img :src="footerInfo.CompanyFullName" />
                <div><i class="iconfont iconweixin"></i>微信</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 客户服务 结束 -->
      </div>
    </div>
    <!-- 底部 -->
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from '../../components/top-nav'
import bottomFooter from '../../components/bottom-footer'
export default {
  components: { topNav, bottomFooter },

  data() {
    return {
      // 顶部大图数据
      bannerList: [],
      // 子级导航
      navSonList: [],
      // 面包屑导航
      crumbs: '',
      // 入驻申请传参
      params: {
        // 名称
        CompanyName: '',
        // 电话
        CompanyPhone: '',
        // QQ/MSN
        CompanyScale: '',
        // 类型
        Nitype: 0,
        // 所在位置
        Address: '',
        // 时间要求
        Sxtime: '',
        // 附加说明
        LegalPerson: ''
      },
      // 项目优势
      advantage: [],
      // 招商政策
      policy: [],
      // 入住申请列表
      settledList: [],
      // 关于我们切换
      enterCurrentIndex: 0,
      // 客户服务
      footerInfo: {},
      // 是手机还是电脑
      showTo: 0
    }
  },

  created() {
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.showTo = 2
    } else {
      this.showTo = 1
    }
    this.getBannerList()
    this.getSubtopicList()
  },

  methods: {
    // 获取顶部大图
    async getBannerList() {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetBannerList?SxType=${this.$route.query.id}&ShowTo=${this.showTo}`
      )
      this.bannerList = res.data
    },

    // 获取子栏目列表
    async getSubtopicList() {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetDhangZiList?ParentId=${this.$route.query.id}`
      )
      this.navSonList = res.data
      if (this.$route.query.sonId) {
        this.enterCurrentIndex = +this.$route.query.sonId
        const res1 = this.navSonList.find(v => v.Id === this.enterCurrentIndex)
        this.handleEnterActive(res1)
      } else {
        this.handleEnterActive(res.data[0])
      }
    },

    // 获取项目优势
    async getAdvantage(id) {
      const { data: res } = await this.$request.post(
        `/SX_TongYong/GetTongYongList?SxType=${id}&ShowTo=${this.showTo}`
      )
      this.advantage = res.data
    },

    // 获取招商政策
    async getPolicy(id) {
      const { data: res } = await this.$request.post(
        `/SX_TongYong/GetTongYongList?SxType=${id}&ShowTo=${this.showTo}`
      )
      this.policy = res.data
    },

    // 入住申请您是
    async getSettledList() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetAllEnumList?enumName=TwenType'
      )
      res.data.unshift({
        Description: '请选择',
        Name: 'qingxuanze',
        Value: 0
      })
      this.settledList = res.data
    },

    // 获取客户服务
    async getFooterInfo() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetSX_CompanyList'
      )
      this.footerInfo = res.data
    },

    // 提交申请
    async handleSubmitFrom() {
      if (
        this.params.CompanyName === '' ||
        this.params.CompanyPhone === '' ||
        this.params.Nitype === 0
      ) {
        return
      }

      const { data: res } = await this.$request.post(
        '/SX_RzhuPpai/AddRzhuInfo',
        this.params
      )
      if (res.errorCode !== 0) return
      alert(res.msg)
      this.handleClearFrom()
    },

    // 重置申请
    handleClearFrom() {
      this.params.CompanyName = ''
      this.params.CompanyPhone = ''
      this.params.CompanyScale = ''
      this.params.Nitype = 0
      this.params.Address = ''
      this.params.Sxtime = ''
      this.params.LegalPerson = ''
    },

    handleEnterActive(item) {
      this.enterCurrentIndex = item.Id
      this.crumbs = item.Title

      if (item.Id === 163) {
        // 项目优势
        this.getAdvantage(item.Id)
      } else if (item.Id === 164) {
        // 招商政策
        this.getPolicy(item.Id)
      } else if (item.Id === 162) {
        // 入驻申请
        this.getSettledList()
      } else {
        // 客户服务
        this.getFooterInfo()
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 面包屑
.crumbs_wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 30px !important;
  color: #666;

  .iconfont {
    color: #c41a26;
    font-size: 20px;
    padding-right: 10px;
  }
}

// 关于我们
.brand_wrap {
  .cut_tier_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0 60px;
    .tier_item {
      padding: 0 16px;
      margin: 0 12px;
      font-size: 16px;
      color: #333;
      cursor: pointer;
    }

    .tier_item:hover {
      text-align: center;
      height: 36px;
      line-height: 36px;
      color: #feeb09 !important;
      background-color: #b92e32;
      border-radius: 100px;
    }
  }

  // 入驻申请 开始
  .settled_wrap {
    .input-group {
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        width: 120px;
        text-align: right;
        padding-right: 30px;
        font-size: 16px;
        color: #666;
      }

      .form-control {
        border-radius: 0;
        background-color: #f3f3f3;
        border: 1px solid #ccc;
        font-size: 14px;
        padding-left: 1.75rem;
      }

      .form-control:focus {
        box-shadow: none;
      }
    }

    .form-group {
      .form-control {
        option {
          background-color: #f3f3f3;
        }
      }
    }

    .btn_wrap {
      padding-left: 120px;

      button {
        border: none;
        padding: 0.3rem 1rem;
      }

      button:nth-child(1) {
        margin-right: 20px;
      }

      button:focus {
        box-shadow: none;
      }

      .btn-primary {
        background-color: #b92e32;
        color: #feeb09;
      }

      .btn-secondary {
        background-color: #ababab;
        color: #fff;
      }
    }

    .title_wrap {
      padding-top: 35px;
      padding-left: 120px;
      font-size: 16px;
      color: #333;
      p:nth-child(1) {
        padding: 0 0 20px;
        margin: 0;
      }
      p:nth-child(2) {
        margin: 0;
        color: #b92e32;
      }
    }
  }
  // 入驻申请 结束

  // 客户服务 开始
  .show_wrap {
    display: flex;
    justify-content: space-between;

    .promise_wrap {
      width: 495px;
      height: 590px;
      background-color: #f2f2f2;
      border-radius: 10px;
      padding-top: 80px;

      img {
        display: block;
        width: 308px;
        height: 56px;
        margin: 0 auto 50px;
      }

      .user {
        font-size: 36px;
        padding-bottom: 45px;
      }

      p {
        font-family: 'Microsoft YaHei';
        font-size: 20px;
        color: #333;
        padding: 14px 0;
        margin: 0;
        text-align: center;
      }
    }

    .relation_wrap {
      width: 590px;

      .phone_box {
        h2 {
          color: #333;
          font-size: 30px;
          margin: 0;
        }

        .phone_ui {
          padding: 28px 0;
          margin: 0;

          .phone_item {
            display: flex;
            align-items: center;
            padding: 17px 0;
            border-bottom: 1px solid #ccc;

            .iconfont {
              font-size: 24px;
              color: #c04f52;
            }

            .title {
              padding-left: 15px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 20px;
              color: #666;
              width: 420px;
            }
          }
        }
      }

      .wx_box {
        h2 {
          color: #333;
          font-size: 30px;
          margin: 0;
        }

        .code_box {
          margin-top: 29px;
          width: 190px;
          height: 220px;
          background-color: #f5f5f5;
          padding-top: 12px;

          img {
            display: block;
            margin: auto;
            width: 167px;
            height: 167px;
          }

          div {
            padding-top: 12px;
            text-align: center;
            font-size: 16px;
            color: #666;
            .iconfont {
              padding-right: 8px;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
  // 客户服务 结束
}

// 通用
.dynamic_wrap {
  padding: 70px 0;

  .dynamic_title {
    text-transform: uppercase;
    text-align: center;
    div:nth-child(1) {
      padding-bottom: 17px;
      font-size: 30px;
      color: #b92e32;
    }

    div:nth-child(2) {
      align-items: center;
      font-size: 16px;
      color: #999;
    }
  }
}

// 关于我们切换
.enter_active {
  text-align: center;
  height: 36px;
  line-height: 36px;
  color: #feeb09 !important;
  background-color: #b92e32;
  border-radius: 100px;
}

// bootstrap
.breadcrumb {
  padding: 0;
  margin: 0;
  border-radius: 0;
  background-color: transparent;
}

// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

@media screen and (max-width: 480px) {
  .type_area {
    width: 375px;
  }

  .iconfont {
    padding: 0 10px;
  }

  .brand_wrap {
    .dynamic_wrap {
      padding: 30px 0;
      .advantage_wrap {
        padding: 0 20px;
      }

      // 入驻申请 开始
      .settled_wrap {
        .input-group {
          div {
            width: 105px;
            padding-right: 10px;
          }

          .form-control {
            padding-left: 0.75rem;
            margin-right: 20px;
          }
        }

        .btn_wrap {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
        }

        .title_wrap {
          padding: 17px 20px 0;
        }
      }
      // 入驻申请 结束

      // 客户服务 开始
      .show_wrap {
        display: block;

        .promise_wrap {
          padding-top: 40px;
          width: 360px;
          margin: auto;
          // padding: 0 5px;
          height: 465px;
          border-radius: 10px;

          img {
            display: block;
            width: 308px;
            height: 56px;
            margin: 0 auto 25px;
          }

          .user {
            font-size: 36px;
            padding-bottom: 22px;
          }
        }

        .relation_wrap {
          width: 100vw;
          .phone_box {
            padding: 20px 0;
            h2 {
              font-size: 24px;
              padding-left: 20px;
            }
          }

          .phone_ui {
            padding: 0;
            margin: 0;

            .phone_item {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 17px 0;
              border-bottom: 1px solid #ccc;

              .iconfont {
                padding-left: 0;
                font-size: 20px;
                color: #c04f52;
              }

              .title {
                padding-left: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 18px;
                color: #666;
                width: 270px;
              }
            }
          }

          .wx_box {
            h2 {
              font-size: 24px;
              padding-left: 20px;
            }

            .code_box {
              margin: auto;
              margin-top: 29px;
              width: 190px;
              height: 220px;
              background-color: #f5f5f5;
              padding-top: 12px;
            }
          }
        }
      }
      // 客户服务 结束
    }

    .cut_tier_wrap {
      padding: 30px 0;
      .tier_item {
        padding: 0 12px;
        margin: 0;
      }
    }
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
